/**
 * Entrypoint for the customize screen itself (the left sidebar).
 */ import "@devowl-wp/utils/antd.scss";
import "./style/admin.scss";
import { applyCustomizeBannerSidebar } from "./others/customizeBannerSidebar.js";
applyCustomizeBannerSidebar();
export * from "./store/index.js";
